export enum DataExportScope {
  Excel = 'excel',
  Csv = 'csv'
}
